import React from 'react'
import { Controller } from 'react-hook-form'
import UserFormField from '../UserFormField'
import { useFormContextUser } from '../utils/_utils'

const Idnps: React.FC = () => {
    const { control } = useFormContextUser()

    return (
        <Controller
            control={control}
            name="idnps"
            render={({ field, fieldState: { error } }) => (
                <UserFormField
                    variant="input"
                    label="Identifiant national"
                    locked
                    status={{
                        error,
                        valid: (field.value?.trim().length ?? 0) > 0,
                    }}
                    placeholder="Identifiant national"
                    dataCyScope="UserField"
                    {...field}
                    value={field?.value ?? ''}
                    disabled
                />
            )}
        />
    )
}

export default Idnps
